'use client';
import { Layout } from '@sbercloud/uikit-product-site-layout';
import { PropsWithChildren, useRef } from 'react';

import { ScrollToTop } from '@/components/static';
import { SearchModal } from '@/components/static/InitialSearch';

import { Header } from './Header';
import s from './styles.module.scss';

export function AppLayout({ children }: PropsWithChildren) {
  const layoutWrapperRef = useRef<HTMLDivElement | null>(null);

  return (
    <div ref={layoutWrapperRef} className={s.app_wrapper}>
      <Layout className={s.root_layout_wrapper}>
        <Header />

        <Layout.Main>
          {children}
          <ScrollToTop layoutWrapperRef={layoutWrapperRef} />
        </Layout.Main>

        <SearchModal />
      </Layout>
    </div>
  );
}
